let intlInstance = null;

export const setIntl = (intl) => {
  intlInstance = intl;
};

export const getIntl = () => {
  if (!intlInstance) {
    throw new Error('Intl instance not set');
  }

  return intlInstance;
};
